module.exports = __webpack_public_path__ + "img/full1-min.774595f9.png";